import styled from 'styled-components'

import { ButtonIcon } from '@/components/business/visitor-parking/button-icon'

export const Title = styled.h1(({ theme }) => ({
  color: theme.colors.black800,
  fontSize: '3.6rem',
  fontWeight: 600,
  textAlign: 'center',
}))

export const Heading = styled.h3(({ theme }) => ({
  color: theme.colors.black800,
  fontSize: '2rem',
  fontWeight: 600,
  marginBottom: theme.space['12'],
}))

export const DurationLabel = styled.label(({ theme }) => ({
  color: theme.colors.black800,
  fontSize: '1.4rem',
  fontWeight: 600,
}))

export const DurationSelector = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.space['8'],
  marginBottom: theme.space['12'],
  width: '100%',
}))

export const DurationPreview = styled.div(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.colors.gray100,
  border: `${theme.border.size['1']} solid ${theme.colors.gray500}`,
  borderRadius: theme.border.radius['4'],
  color: theme.colors.black700,
  display: 'flex',
  fontSize: '1.4rem',
  fontWeight: 400,
  height: '4rem',
  justifyContent: 'center',
  width: '100%',
}))

export const DurationSelectorButton = styled(ButtonIcon)(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.colors.black800,
  borderRadius: theme.border.radius['12'],
  color: theme.colors.white,
  display: 'flex',
  height: '4rem',
  justifyContent: 'center',
}))

export const CostTitle = styled.p(({ theme }) => ({
  color: theme.colors.black800,
  fontSize: '1.8rem',
  fontWeight: 600,
}))

export const CostDescription = styled.p(({ theme }) => ({
  color: theme.colors.black500,
  fontSize: '1.2rem',
  fontWeight: 500,
}))
